const useQuery = (id) => {
  const params = new URLSearchParams(window.location.search);
  return params.get(id);
};

const getNativeParam = () => {
  return useQuery("native");
};

export const isNative = () => {
  const value = getNativeParam();
  return value !== null;
};



/** WEBPACK FOOTER **
 ** ./src/js/utils/native.js
 **/